import { StyleSheet } from 'react-native';
import { BLACK, BLACK_500, BLACK_700, BLACK_900, LILAC_200, LILAC_300, LILAC_400, LILAC_600, LILAC_800, WHITE } from '../../../../constants';
import { getCurrentEventControlState } from '../../../../utils';
export var config = {
  size: {
    sm: {
      buttonSize: 32,
      iconSize: 12
    },
    md: {
      buttonSize: 40,
      iconSize: 20
    },
    lg: {
      buttonSize: 48,
      iconSize: 28
    }
  },
  controlState: {
    none: {
      buttonColor: LILAC_400,
      iconColor: BLACK_900,
      borderColor: LILAC_600,
      borderWidth: 1
    },
    disabled: {
      buttonColor: BLACK_500,
      iconColor: BLACK_700
    },
    hover: {
      buttonColor: LILAC_200,
      borderColor: LILAC_300,
      iconColor: BLACK_700,
      borderWidth: 1
    },
    pressed: {
      buttonColor: LILAC_600,
      iconColor: BLACK,
      borderWidth: 1,
      borderColor: LILAC_800
    },
    selected: {
      buttonColor: BLACK_900,
      iconColor: WHITE
    }
  }
};
export var getCarouselButtonStyles = (props, event) => {
  var _a, _b, _c;
  var _props$controlState = props.controlState,
    controlState = _props$controlState === void 0 ? 'none' : _props$controlState,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size;
  var _controlState = getCurrentEventControlState(event, controlState);
  var buttonTypeControlState = (_a = config === null || config === void 0 ? void 0 : config.controlState) === null || _a === void 0 ? void 0 : _a[_controlState];
  var buttonSize = (_c = (_b = config === null || config === void 0 ? void 0 : config.size) === null || _b === void 0 ? void 0 : _b[size]) === null || _c === void 0 ? void 0 : _c.buttonSize;
  return StyleSheet.create({
    container: {
      backgroundColor: buttonTypeControlState === null || buttonTypeControlState === void 0 ? void 0 : buttonTypeControlState.buttonColor,
      borderWidth: buttonTypeControlState === null || buttonTypeControlState === void 0 ? void 0 : buttonTypeControlState.borderWidth,
      borderColor: buttonTypeControlState === null || buttonTypeControlState === void 0 ? void 0 : buttonTypeControlState.borderColor,
      width: buttonSize,
      height: buttonSize,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: buttonSize * 2
    },
    innerContainerStyle: {}
  });
};
export var getCarouselButtonProps = (props, context) => {
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState);
  return Object.assign(Object.assign({
    theme
  }, props), {
    controlState
  });
};